import { render, staticRenderFns } from "./TableAmountsByProvider.vue?vue&type=template&id=0dd56086&"
import script from "./TableAmountsByProvider.vue?vue&type=script&lang=js&"
export * from "./TableAmountsByProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports